
const FAQIdType = Symbol();

export class FAQId {
    [FAQIdType]: any;
    readonly value: string;

    private constructor(faqId: string) {
        this.value = faqId;
    }

    static fromString(faqId: string): FAQId {
        return new FAQId(faqId);
    }
}
